/**
 * 门户默认配置数据
 */
export const home = [{}]

/**
 * 大屏默认配置数据
 */
export const bs = [{}]

/**
 * app边框配置数据
 */
export const appHome = [{}]
